import MuiStep from "@mui/material/Step";
import React from "react";
export interface StepProps {
    /**
     * Should be `Step` sub-components such as `StepLabel`
     */
    children: React.ReactNode;
}
export function Step({ children, ...props }: StepProps) {
    // MUI injects some additional props to Step so we must spread in any excess props.
    return <MuiStep {...props}>{children}</MuiStep>;
}
